// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/stakeholders/firstparty/v1/list_stakeholders.proto

/* oxlint-disable */
import { ApiStakeholder } from "./stakeholder";

/** Request message for listing stakeholders */
export interface ApiListStakeholdersRequest {
  /** The ID of the organization to retrieve stakeholders for */
  readonly organizationId: string;
}

/** Response message for listing stakeholders */
export interface ApiListStakeholdersResponse {
  /** List of stakeholders for the organization */
  readonly stakeholders: readonly ApiStakeholder[];
}

/** Error codes for ListStakeholders operation */
export interface ApiListStakeholdersErrors {
}

/** Bad request error codes */
export const ApiListStakeholdersErrorsBadRequestError = {
  /** BAD_REQUEST_ERROR_UNSPECIFIED - Unspecified bad request error */
  BAD_REQUEST_ERROR_UNSPECIFIED: "BAD_REQUEST_ERROR_UNSPECIFIED",
  /** BAD_REQUEST_ERROR_VALIDATION_FAILED - Validation failed */
  BAD_REQUEST_ERROR_VALIDATION_FAILED: "BAD_REQUEST_ERROR_VALIDATION_FAILED",
} as const;

export type ApiListStakeholdersErrorsBadRequestError =
  typeof ApiListStakeholdersErrorsBadRequestError[keyof typeof ApiListStakeholdersErrorsBadRequestError];

export namespace ApiListStakeholdersErrorsBadRequestError {
  export type BAD_REQUEST_ERROR_UNSPECIFIED =
    typeof ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  export type BAD_REQUEST_ERROR_VALIDATION_FAILED =
    typeof ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
}

export function apiListStakeholdersErrorsBadRequestErrorFromJSON(
  object: any,
): ApiListStakeholdersErrorsBadRequestError {
  switch (object) {
    case 0:
    case "BAD_REQUEST_ERROR_UNSPECIFIED":
      return ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
    case 1:
    case "BAD_REQUEST_ERROR_VALIDATION_FAILED":
      return ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED;
    default:
      return ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED;
  }
}

export function apiListStakeholdersErrorsBadRequestErrorToJSON(
  object: ApiListStakeholdersErrorsBadRequestError,
): string {
  switch (object) {
    case ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_UNSPECIFIED:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
    case ApiListStakeholdersErrorsBadRequestError.BAD_REQUEST_ERROR_VALIDATION_FAILED:
      return "BAD_REQUEST_ERROR_VALIDATION_FAILED";
    default:
      return "BAD_REQUEST_ERROR_UNSPECIFIED";
  }
}

export const ApiListStakeholdersRequest: MessageFns<ApiListStakeholdersRequest> = {
  fromJSON(object: any): ApiListStakeholdersRequest {
    return { organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "" };
  },

  toJSON(message: ApiListStakeholdersRequest): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    return obj;
  },
};

export const ApiListStakeholdersResponse: MessageFns<ApiListStakeholdersResponse> = {
  fromJSON(object: any): ApiListStakeholdersResponse {
    return {
      stakeholders: globalThis.Array.isArray(object?.stakeholders)
        ? object.stakeholders.map((e: any) => ApiStakeholder.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListStakeholdersResponse): unknown {
    const obj: any = {};
    if (message.stakeholders?.length) {
      obj.stakeholders = message.stakeholders.map((e) => ApiStakeholder.toJSON(e));
    }
    return obj;
  },
};

export const ApiListStakeholdersErrors: MessageFns<ApiListStakeholdersErrors> = {
  fromJSON(_: any): ApiListStakeholdersErrors {
    return {};
  },

  toJSON(_: ApiListStakeholdersErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
